const EXPLAINED_BY_SERVER = [400, 403, 409];

/** Отказы и запреты объясняет сервер; для остальных ошибок действия оставляем общее сообщение. */
export const describeApiError = (error, fallback) => (
    EXPLAINED_BY_SERVER.includes(error?.status) && error.message ? error.message : fallback
);
